import React from 'react';

import TrialPeriodModal from '../../components/TrialPeriodModal';
import { useTrialPeriod } from '../../hooks/useTrialPeriod';
import InviteAdminUser from './InviteAdmin';

const SuperAdmin = () => {
  const { showTrialModal, closeTrialModal } = useTrialPeriod();

  return (
    <React.Fragment>
      <InviteAdminUser />

      <TrialPeriodModal open={showTrialModal} onClose={closeTrialModal} />
    </React.Fragment>
  );
};

export default SuperAdmin;
